module.exports = __webpack_public_path__ + "static/media/annavaram_group_image.ebc16e90.png";